export const devBaseUrl = 'http://192.168.100.88:8000/'
export const prodBaseUrl = 'https://gobeyound.com/'
export const usersUrl = '/api/v1/users'
export const clientsUrl = '/api/v1/clients'
export const uploadsUrl = '/api/v1/beyound-uploads/upload'
export const moveUploadsUrl = '/api/v1/beyound-uploads/move'
export const libraryUrl = '/api/v1/beyound-uploads/library'
export const projectsUrl = '/api/v1/beyound-projects/all'
export const srcCodeUrl = '/api/v1/beyound-src/code'
const token = localStorage['BUND-X-AUTH-TOKEN']

export const requestOptions = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: `Bearer ${token}`
  }
}

export const getRequest = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
}

export const postRequest = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
}
